import { Headers } from 'shared/constants/headers';

export interface UploadMultipartImageSuccess {
  success: boolean;
  response: Response;
}

export interface UploadMultipartImageError {
  success: boolean;
  error: Error;
}

export type UploadMultipartImageResult =
  UploadMultipartImageSuccess | UploadMultipartImageError;

export const uploadMultipartImage = async (
  url: string,
  body: FormData,
  headers?: Headers,
): Promise<UploadMultipartImageResult> => {
  try {
    const response = await fetch(url, {
      method: 'POST',
      cache: 'no-cache',
      body: body,
      // Omit Content-Type so fetch generates the multipart boundary itself; a manual value breaks S3 parsing.
      headers,
    });

    if (!response.ok) {
      throw new Error(`Error ${response.status}: ${response.statusText}`);
    }
    return { success: true, response };
  } catch (error) {
    return {
      success: false,
      error: error instanceof Error ? error : new Error('Unknown error'),
    };
  }
};

export default uploadMultipartImage;
